<template>
  <report
    collection="standardItems/items"
    currentItemIdGetter="standardItems/items/currentID"
    :defaultPagination="pagination"
    deleteManyAction="standardItems/items/deleteMany"
    :dialogOptions="dialogOptions"
    emptyCurrentItemAction="standardItems/items/emptyCurrent"
    :formDialogComponent="$options.components.StandardItemForm"
    :filters="filters"
    getSelected="standardItems/items/selected"
    :headers="headers"
    itemGetter="standardItems/items/standardItem"
    itemsGetter="standardItems/itemTypes/currentTypeItems"
    perimeter="standardItems"
    :route="route"
    setCurrentItemAction="standardItems/items/setCurrent"
    :title="title"
    updateManyAction="standardItems/items/updateMany"
    updateSelected="standardItems/items/updateSelected"
    >
    <template slot="additional-select-options">
      <v-menu
        v-if="$can('update', 'standardItems')"
        v-model="moveToDialog"
        :close-on-content-click="false"
      >
        <v-tooltip bottom slot="activator">
          <v-btn
            slot="activator"
            class="my-0 mx-0"
            icon
            >
            <v-icon>mdi-folder-move</v-icon>
          </v-btn>
          <span>Move To</span>
        </v-tooltip>
        <TreeMenu @moveSelected="moveSelected" @close="moveToDialog = false"/>
      </v-menu>
    </template>
  </report>
</template>

<script>
import { pick } from 'lodash/fp'

import { mapGetters, mapActions } from 'vuex'

import Report from '@/components/Report'
import StandardItemForm from './Form/StandardItemForm'
const TreeMenu = () => import('./Tree/TreeMenu')

export default {
  name: 'StandardItemsReport',
  components: {
    Report,
    StandardItemForm,
    TreeMenu
  },
  data () {
    return {
      moveToDialog: false,
      dialogOptions: {},
      pagination: {
        rowsPerPage: 50
      }
    }
  },
  computed: {
    filters () {
      return this.currentType.filters && this.currentType.filters.length
        ? this.currentType.filters
        : []
    },

    headers () {
      return this.currentType &&
      this.currentType.headers &&
      this.currentType.headers.length ? [ ...this.currentType.headers ] : []
    },

    route () { return `/standard-items/${this.currentType.id}/item/` },

    title () { return this.currentType && this.currentType.name },

    ...mapGetters({
      currentType: 'standardItems/itemTypes/currentType',
      currentTypeParents: 'standardItems/itemTypes/currentTypeParents',
      user: 'user/saveUser',
      selectedTypeID: 'standardItems/itemTypes/selectedID',
      selectedType: 'standardItems/itemTypes/selectedType',
      itemTypeParents: 'standardItems/itemTypes/parents/parents',
      itemType: 'standardItems/itemTypes/itemType',
      selected: 'standardItems/items/selected'
    })
  },
  methods: {
    moveSelected () {
      console.log('move selected items to different type')
      console.log('selectedTypeID: ', this.selectedTypeID)
      console.log('selectedType: ', this.selectedType)
      console.log('selectedItems: ', this.selected)
      const selectedTypeParents = this.itemTypeParents(this.selectedTypeID)
      const pickFields = ['id', 'level', 'name', 'timestamp', 'level', 'root']

      let parentTypes = {}
      for (const key in selectedTypeParents) {
        let fullParent = this.itemType(key)
        parentTypes[key] = pick(pickFields)(fullParent)
      }

      console.log('parentTypes: ', parentTypes)

      const updatedTypes = {
        ...parentTypes,
        [this.selectedTypeID]: pick(pickFields)(this.selectedType)
      }

      const updatedItems = this.selected.map(item => {
        return {
          ...item,
          types: { ...updatedTypes }
        }
      })

      console.log('updatedItems: ', updatedItems)
      this.updateManyItems(updatedItems)
        .then(() => {
          this.updateSelected([])
          this.moveToDialog = false
        })
    },

    ...mapActions({
      'updateManyItems': 'standardItems/items/updateMany',
      'updateSelected': 'standardItems/items/updateSelected'
    })
  }
}
</script>

<style>
</style>
